document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function () {
        if ( document.querySelectorAll('.logoLine').length ) {

            const elements = document.querySelectorAll('.logoLine');

            console.log(elements);

            elements.forEach(function(element) {
                let timeline = gsap.timeline();
                timeline.to(element.querySelectorAll('div.fill'), { height: "100%"});
                timeline.to(element.querySelectorAll('svg'), { y: element.querySelector('.line').offsetHeight* 0.88 }, "<");

                ScrollTrigger.create({
                    trigger: element,
                    scrub: 0.5,
                    animation: timeline,
                    start: 'top 50%',
                    end: 'bottom 10%',
                    toggleActions: "play reverse play reverse",
                    //markers: true,
                    immediateRender: false,
                });
            });

        }
    });
});
